import React from 'react';

// Small pill marking a card/contact as managed in GoHighLevel (ticket 122 S6).
// `detached` = the GHL ref used to point here but the record is gone there now.
export default function GhlBadge({ detached = false }) {
  return (
    <span
      data-testid="ghl-badge"
      title={detached ? 'GHL link detached' : 'Managed in GoHighLevel'}
      className="inline-flex items-center text-[10px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-full"
      style={detached ? { background: '#E2E8F0', color: '#475569' } : { background: '#EEF2FF', color: '#3730A3' }}
    >
      GHL
    </span>
  );
}
